import numeral from 'numeral';

function formatNumber(number) {
  if (number == undefined) { return ''; }
  return numeral(number).format('0,0');
}

export default formatNumber;
